function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "ClearbitIcon_svg__30_a",
  d: "M4.273 0h7.454c1.486 0 2.025.155 2.568.445.543.29.97.717 1.26 1.26.29.543.445 1.082.445 2.568v7.454c0 1.486-.155 2.025-.445 2.568-.29.543-.717.97-1.26 1.26-.543.29-1.082.445-2.568.445H4.273c-1.486 0-2.025-.155-2.568-.445a3.029 3.029 0 01-1.26-1.26C.155 13.752 0 13.213 0 11.727V4.273c0-1.486.155-2.025.445-2.568.29-.543.717-.97 1.26-1.26C2.248.155 2.787 0 4.273 0z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "ClearbitIcon_svg__31_b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#ClearbitIcon_svg__30_a"
})), React.createElement("use", {
  fill: "#3386EE",
  xlinkHref: "#ClearbitIcon_svg__30_a"
}), React.createElement("path", {
  fill: "#61ADF7",
  mask: "url(#ClearbitIcon_svg__31_b)",
  d: "M8 0h8v16H8z"
}), React.createElement("path", {
  fill: "#F3F9FE",
  mask: "url(#ClearbitIcon_svg__31_b)",
  d: "M8 8h8v8H8z"
}));

var SvgClearbitIcon = function SvgClearbitIcon(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref, _ref2);
};

export default SvgClearbitIcon;